import { IonIcon } from '@ionic/react';
import { chevronForwardOutline } from 'ionicons/icons';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useInvoices } from '../../../hooks/InvoiceHooks';
import { Invoice } from '../../../model/invoices/invoices';
import { InvoiceModal } from './InvoiceModal';

type InvoiceContentProps = {
  key: number;
  invoice: Invoice;
};

export const InvoiceContent: React.FC<InvoiceContentProps> = ({ invoice }) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const { invoiceService } = useInvoices();
  const invoiceDate = invoiceService.formatDate(invoice.issueDate);
  return (
    <li className="flex flex-row w-full text-left bg-white border border-primary border-opacity-40 rounded-xl my-3">
      <InvoiceModal
        invoice={invoice}
        showModal={showModal}
        setShowModal={setShowModal}
        invoiceDate={invoiceDate}
      >
        <div
          onClick={() => setShowModal(true)}
          className="flex flex-row justify-between items-center p-6 py-5 cursor-pointer"
        >
          <h3 className=" text-black font-medium text-sm">
            <FormattedMessage id="Invoice" />
            {' #' +
              invoice.number +
              ' - ' +
              invoiceDate +
              ' ' +
              invoice.issueDate?.split('-')[0]}
          </h3>
          <div className="h-full flex items-left md:flex md:flex-col">
            <IonIcon icon={chevronForwardOutline}></IonIcon>
          </div>
        </div>
      </InvoiceModal>
    </li>
  );
};

export default InvoiceContent;
